import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { OBSERVABILITY_ENV, SENTRY_DSN, VERSION } from '@constants/config';

const isLocalEnv = () => OBSERVABILITY_ENV === 'local';
const isProd = () => OBSERVABILITY_ENV === 'production';

const init = () =>
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: OBSERVABILITY_ENV,
    release: VERSION,
    normalizeDepth: 4,
    integrations: [
      Sentry.browserTracingIntegration({ traceFetch: false }),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: isProd() ? 0.1 : 1.0,
  });

(() => !isLocalEnv() && init())();
